import Reflux from 'reflux';

const AlertReceiverActions = Reflux.createActions({
  'addReceiver': { asyncResult: true },
  'deleteReceiver': { asyncResult: true },
  'sendDummyAlert': { asyncResult: true },
});

export default AlertReceiverActions;



// WEBPACK FOOTER //
// ../graylog2-server/graylog2-web-interface/src/actions/alertreceivers/AlertReceiversActions.jsx